// @flow
import { TreeList } from './tree-list';
import { default as TreeListTemplate } from './templates/tree-list.html';

export const COMPONENTS_TREE_LIST_NAME = 'tree-list';
export const COMPONENTS_TREE_LIST_ENTITIES = [{
	name: COMPONENTS_TREE_LIST_NAME,
	entity: TreeList,
	template: TreeListTemplate,
}];
